/* eslint-disable */

import ResourcePattern from '@/services/resource-patters';

export default ResourcePattern('Sync', 'transactions', ({ Api, servicename, resource }) => ({
  actions: {
    async get(_, { params }) {
      const { data, headers } = await Api.get(servicename, resource, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async getByCompany(_, { companyId, params }) {
      const { data, headers } = await Api.get(servicename, `${resource}/company/${companyId}`, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async getMetadata(_, { transactionId, params }) {
      const { data, headers } = await Api.get(servicename, `${resource}/${transactionId}/metadata`, { params });
      return {
        data,
        total: Number(headers['x-total-count']),
      };
    },
    async count(_, { params }) {
      const { data } = await Api.get(servicename, `${resource}/count`, { params });
      return data;
    },
    async findByCompany(_, { companyId, id, params }) {
      const { data } = await Api.get(servicename, `${resource}/company/${companyId}/${id}`, { params });
      return data;
    },
    async find(_, { id, params }) {
      const { data } = await Api.get(servicename, `${resource}/${id}`, { params });
      return data;
    },
    async delete(_, { id }) {
      await Api.delete(servicename, `${resource}/${id}`);
    },
    async create(_, { dataForm }) {
      const { data } = await Api.post(servicename, `${resource}`, dataForm);
      return data;
    },
    async update(_, { id, dataForm }) {
      const { data } = await Api.patch(servicename, `${resource}/${id}`, dataForm);
      return data;
    },
    async getUrlDownload(_, { id, usernames, userId }) {
      const urlBase = await Api.getUrl(servicename, resource);
      const params = new URLSearchParams({
        access_token: Api?.token ?? '',
        usernames: JSON.stringify(usernames),
        userId: userId ?? ''
      });
      return `${urlBase}/${id}/download?${params.toString()}`;
    },
    async getUrlDownloadByCompany(_, { companyId, id, usernames, userId }) {
      const urlBase = await Api.getUrl(servicename, resource);
      const params = new URLSearchParams({
        access_token: Api?.token ?? '',
        usernames: JSON.stringify(usernames),
        userId: userId ?? ''
      });
      return `${urlBase}/${companyId}/${id}/download?${params.toString()}`;
    },
  },
}));
/* eslint-enable */
